import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="page-content">
        <h2>404 - 頁面未找到</h2>
        <p>抱歉，您要查找的頁面不存在。</p>
        <Link to="/bible-study-materials">
            <button className='button button-m'>
                返回【網站首頁】
            </button>
        </Link>
    </div>
  );
}

export default NotFound;
